import React from "react";
import {
  Datagrid,
  ReferenceManyField,
  SingleFieldList,
  ChipField,
  List,
  TextField,
} from "react-admin";


export const TagList = (props) => {
  return (
    <List
      {...props}
     
    >
      <Datagrid rowClick="edit">
        <TextField source="id" />
        <TextField source="name" />

        <ReferenceManyField reference="Mindfulness" target="tag_some" label="Mindfulness (benzerler)">
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceManyField>

      </Datagrid>
    </List>
  );
};